module.exports = __webpack_public_path__ + "static/media/19,055.5f710457.webp";